<template>
  <div class="toolbar bg-base-100 shadow-sm p-2 sm:p-4">
    <!-- 移动端布局 -->
    <div class="block">
      <div class="flex gap-2 items-center">
        <button
          :class="['btn btn-xs', isZoomMode ? 'btn-primary' : 'btn-outline']"
          @click="$emit('mode-change', EditorMode.ZOOM)"
        >
          <i class="iconfont icon-hand" />
        </button>

        <button
          :class="['btn btn-xs', isEditMode ? 'btn-primary' : 'btn-outline']"
          @click="$emit('mode-change', EditorMode.PAINT)"
        >
          <i class="iconify mdi--pencil"></i>
        </button>
        <button
          :class="['btn btn-xs', isEraserTool ? 'btn-primary' : 'btn-outline']"
          @click="$emit('mode-change', EditorMode.ERASER)"
        >
          <i class="iconify mdi--eraser"></i>
        </button>

        <button
          :class="[
            'btn btn-xs',
            isEyedropperTool ? 'btn-primary' : 'btn-outline',
          ]"
          @click="$emit('mode-change', EditorMode.EYEDROPPER)"
        >
          <i class="iconify mdi--eyedropper"></i>
        </button>
        <ColorPicker
          :model-value="color"
          @update:model-value="$emit('color-change', $event)"
        />

        <van-divider vertical class="border-base-content" />

        <button
          :class="['btn btn-xs']"
          :disabled="!canUndo"
          @click="$emit('undo')"
        >
          <i class="iconify mingcute--back-line" />
        </button>
        <button
          :class="['btn btn-xs']"
          :disabled="!canRedo"
          @click="$emit('redo')"
        >
          <i class="iconify mingcute--back-line scale-x-[-1]" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ColorPicker from "./ColorPicker.vue";
import { EditorMode } from "./config";
import type { CanvasState, HistoryState } from "./types";

const props = defineProps<{
  canvasState: CanvasState;
  historyState: HistoryState;
}>();
defineEmits<{
  (e: "mode-change", mode: EditorMode): void;
  (e: "color-change", color: string): void;
  (e: "undo"): void;
  (e: "redo"): void;
}>();

// 计算属性
const isEditMode = computed(() => props.canvasState.mode === EditorMode.PAINT);
const isZoomMode = computed(() => props.canvasState.mode === EditorMode.ZOOM);
const isEraserTool = computed(
  () => props.canvasState.mode === EditorMode.ERASER
);
const isEyedropperTool = computed(
  () => props.canvasState.mode === EditorMode.EYEDROPPER
);
const color = computed(() => props.canvasState.color);
const canUndo = computed(() => props.historyState.canUndo);
const canRedo = computed(() => props.historyState.canRedo);
</script>

<style scoped>
.btn-group .btn {
  border-radius: 0;
}

.btn-group .btn:first-child {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.btn-group .btn:last-child {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
</style>
